import React from 'react';
import { Button, ButtonTheme } from '@apply/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLessThan } from '@fortawesome/free-solid-svg-icons';

interface WizardFooterProps {
    onBack?: () => void;
    onNext?: () => void;
    onSkip?: () => void;
    nextLabel?: string;
    canGoNext: boolean;
    isSaving?: boolean;
    showBack?: boolean;
}

export const WizardFooter: React.FC<WizardFooterProps> = ({
    onBack,
    onNext,
    onSkip,
    nextLabel = 'Save and Continue',
    canGoNext,
    isSaving = false,
    showBack = true,
}) => (
    <div className='bpWizard-navigationButtons'>
        <div style={{ float: 'right' }}>
            <Button
                id='bpWizard-backButton'
                dataTestid='bpWizardBackButton'
                theme={ButtonTheme.LinkBlue}
                handleClick={onBack}
                disabled={isSaving}
                visible={showBack}
            >
                <span style={{ paddingRight: '5px' }}>
                    <FontAwesomeIcon icon={faLessThan} />
                </span>
                Back
            </Button>
        </div>

        {onSkip && (
            <Button
                id='bpWizard-skipButton'
                dataTestid='bpWizardSkipButton'
                theme={ButtonTheme.LinkBlue}
                handleClick={onSkip}
                disabled={isSaving}
            >
                Skip
            </Button>
        )}

        <Button
            id='bpWizard-nextButton'
            dataTestid='bpWizardNextButton'
            theme={ButtonTheme.Primary}
            width='50%'
            maxWidth='346px'
            handleClick={onNext}
            disabled={!canGoNext || isSaving}
        >
            {isSaving ? 'Saving…' : nextLabel}
        </Button>
    </div>
);
